module.exports = __webpack_public_path__ + "img/linked-account.e0150e3e.jpg";